import React, { useEffect } from "react";
import { connect } from "react-redux";
import { socketServer } from "../../assets/socketConnection";
import { Link, useParams } from "react-router-dom";
import { selectUserInfo } from "../../redux/user/user.selectors";
import {
  clearCurrentCard,
  fetchCurrentCardAsync,
  fetchCurrentCardSuccess,
  fetchCurrentCardBitsSuccess,
} from "../../redux/currentReq/currentReq.actions";

import socket from "../../assets/socketConnection";
import CloseBtn from "../../components/closeBtn/closeBtn.component";
import Spinner from "../../components/spinner/spinner.component";
import BitsList from "../../containerSmall/bitsList/bitsList.container";
import ReqCardColored from "../../containerSmall/reqCardColored/reqCardColored.container";
import ReqInfo from "../../containerSmall/reqInfo/reqInfo.container";
import ReqOptions from "../../containerSmall/reqOptions/reqOptions.component";
// import WithSpinner from "../../HOC/withSpinner/WithSpinner.component";
import { ContainerStyled } from "./singleReq.styles";
import { createStructuredSelector } from "reselect";
import {
  selectCurrentReqIsLoading,
  selectCurrentReqInfo,
  selectCurrentReqBits,
  selectCurrentReqBitsIsLoading,
} from "../../redux/currentReq/currentReq.selectors";
import WithSpinner from "../../HOC/withSpinner/WithSpinner.component";
import SelectedBit from "../../containerSmall/selectedBit/selectedBit.container";
import SelectedBitFinal from "../../containerSmall/selectedBitFinal/selectedBitFinal.container";
import SelectedBitFinal3 from "../../containerSmall/selectedBitFinal3/SelectedBitFinal3.component";
import SelectedBitFinal4 from "../../containerSmall/selectedBitFinal4/SelectedBitFinal4.component";
import useMediaQuery from "../../hooks/useMediaQuery";
const BitsListWithSpinner = WithSpinner(BitsList);

const SingleReq = ({
  selectUserInfo,
  selectCurrentReqInfo,
  selectCurrentReqIsLoading,
  selectCurrentReqBits,
  selectCurrentReqBitsIsLoading,
  clearCurrentCard,
  fetchCurrentCardAsync,
  fetchCurrentCardSuccess,
  fetchCurrentCardBitsSuccess,
}) => {
  const { id } = useParams();
  let size = useMediaQuery();
  // debugger;

  // const [isMyReq, setIsMyReq] = useState(false);

  // const [info, setInfo] = useState("");
  // const [bits, setBits] = useState([]);
  // const [isloading, setIsloading] = useState(false);

  //   console.log(id);
  console.log(selectCurrentReqInfo, "single__load");
  const leftColumn = () => {
    switch (selectCurrentReqInfo.status) {
      case 0:
        return (
          <BitsListWithSpinner
            isLoading={selectCurrentReqBitsIsLoading}
            load_data={selectCurrentReqInfo}
            bits={selectCurrentReqBits}
          />
        );

      case 1:
        return (
          <SelectedBit
            bit={selectCurrentReqInfo.selected_driver}
            won_price={selectCurrentReqInfo.won_price}
          />
        );

      case 2:
        if (isMyReq)
          return (
            <SelectedBitFinal
              bit={selectCurrentReqInfo}
              won_price={selectCurrentReqInfo.won_price}
            />
          );
        break;

      case 3:
        if (isMyReq)
          return (
            <SelectedBitFinal3
              bit={selectCurrentReqInfo}
              won_price={selectCurrentReqInfo.won_price}
            />
          );
        break;

      case 4:
        if (isMyReq)
          return (
            <SelectedBitFinal4
              bit={selectCurrentReqInfo}
              won_price={selectCurrentReqInfo.won_price}
            />
          );
        break;

      // case 5:
      //   alert("hi");
      //   return "asdf";

      default:
        return null;
    }
  };

  // const ContainerStyledWithSpinner = WithSpinner(ContainerStyled)

  useEffect(() => {
    window.location.pathname.includes("without") &&
      fetch(`${socketServer}get_load_single_request?id=${id}`)
        .then((res) => res.json())
        .then((res) => {
          fetchCurrentCardSuccess(res[0]);
        });
  }, []);
  useEffect(() => {
    window.location.pathname.includes("without") &&
      fetch(`${socketServer}get_load_bits_nologin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ load_id: selectCurrentReqInfo._id }),
      })
        .then((res) => res.json())
        .then((res) => {
          console.log("nologgingdata", res);
          fetchCurrentCardBitsSuccess(res);
        });
  }, [selectCurrentReqInfo]);
  useEffect(() => {
    fetchCurrentCardAsync(socket, id);

    // setIsloading(true);
    // fetch(`http://217.11.29.130:88/get_load_single_request?id=${id}`)
    //   .then((res) => res.json())
    //   .then((res) => {
    //     setInfo(res[0]);
    //     socket.emit("get_bits", { load_id: res[0].id });
    //   });
    // socket.emit("get_loads", {
    //   filter: { id },
    // });
    // socket.on("response_loads", async (data) => {
    //   // alert(data.length !== 1);
    //   if (data.length !== 1) return;
    //   // alert(2);
    //   // console.log("123123", data);
    //   setInfo(data[0]);
    //   socket.emit("get_bits", { load_id: data[0].id });
    //   // dispatch(fetchAllReqsSuccess(data));
    // });
    // // alert("emited");
    // socket.on("response_bits", (data) => {
    //   // console.log(data);
    //   setBits(data);
    //   setIsloading(false);

    // console.log(process.env);
    // debugger;
    // });

    // if (
    //   selectCurrentReqInfo &&
    //   selectCurrentReqInfo.owner_id.id === selectUserInfo.id
    // )
    //   setIsMyReq(true);
    // debugger;
    return () => {
      clearCurrentCard();
      // alert("ceared");
    };
  }, []);
  // console.log(selectUserInfo.id, "selectUserInfo");
  // console.log(selectCurrentReqInfo, "selectCurrentReqIsLoading");
  // console.log(selectCurrentReqInfo, "selectCurrentReqInfo");
  console.log(selectCurrentReqBitsIsLoading, "selectCurrentReqcBitsIsLoading");
  // alert("hi");
  const isMyReq = selectCurrentReqInfo.owner_id
    ? selectCurrentReqInfo &&
      selectCurrentReqInfo.owner_id.id === selectUserInfo.id
    : null;

  // alert("hisadf");
  return (
    <div>
      {!selectCurrentReqIsLoading ? (
        <ContainerStyled size={size}>
          <div>
            {
              // selectCurrentReqInfo &&
              // // selectCurrentReqInfo.owner_id &&X
              // isMyReq
              isMyReq ? <ReqOptions info={selectCurrentReqInfo} /> : null
            }

            <ReqCardColored info={selectCurrentReqInfo} />
            <ReqInfo info={selectCurrentReqInfo} />
          </div>

          {leftColumn()}
          {window.location.pathname.includes("without") ? (
            <Link
              to="/app2/without"
              style={{ position: "absolute", left: 0, top: 0 }}
            >
              <CloseBtn />
            </Link>
          ) : (
            <Link
              to="/app2/reqs"
              style={{ position: "absolute", left: 0, top: 0 }}
            >
              <CloseBtn />
            </Link>
          )}
        </ContainerStyled>
      ) : (
        // <div>hi</div>
        <Spinner />
      )}
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  selectUserInfo: selectUserInfo,

  selectCurrentReqInfo: selectCurrentReqInfo,
  selectCurrentReqIsLoading: selectCurrentReqIsLoading,

  selectCurrentReqBits: selectCurrentReqBits,
  selectCurrentReqBitsIsLoading: selectCurrentReqBitsIsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCurrentCardAsync: (x, y) => dispatch(fetchCurrentCardAsync(x, y)),
  fetchCurrentCardSuccess: (x) => dispatch(fetchCurrentCardSuccess(x)),
  fetchCurrentCardBitsSuccess: (x) => dispatch(fetchCurrentCardBitsSuccess(x)),
  clearCurrentCard: () => dispatch(clearCurrentCard()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleReq);
